import React, { useState } from "react";
import { Modal, Form, Input, Upload, notification } from "antd";
import axiosInstance from "utilities/axios";

const RepairModal = ({ request, open, onClose, onUpdate }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  const handleOk = () => {
    form.validateFields().then((values) => {
        if (!values.attachments && (!values.cost || values.cost === request.estimatedPrice)) {
            notification.error({
                message: "Error",
                description: "Please enter a new cost or attach a file",
            });
            return;
        }

      setLoading(true);
      const formData = new FormData();
      formData.append("type", "Repair");
      formData.append("cost", values.cost);
      values.attachments?.fileList.forEach((file) => {
        formData.append("attachments", file.originFileObj);
      });

      axiosInstance
        .put(`/equipment/requests/${request.id}`, formData)
        .then((response) => {
          notification.success({
            message: "Success",
            description: "Request submitted successfully!",
          });
          onUpdate();
          onClose();
        })
        .catch((error) => {
          notification.error({
            message: "Error",
            description: error.message,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  return (
    <Modal
        title="Request Repair"
        open={open}
        onCancel={handleCancel}
        okText="Submit"
        okButtonProps={{ loading }}
        onOk={handleOk}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="cost"
          label="Estimated Cost"
          rules={[
            {
              required: false,
              message: "Please enter the cost",
            },
          ]}
        >
          <Input type="number" prefix="$"/>
        </Form.Item>
        <Form.Item
          name="attachments"
          label="Attachments"
          help="You can attach multiple files"
        >
          <Upload.Dragger
            action="/upload.do"
            listType="text"
            beforeUpload={() => false}
            multiple
          >
            <p className="ant-upload-text">
              Drag & drop certificate or click to upload
            </p>
          </Upload.Dragger>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RepairModal;
